import React, { useEffect } from "react";

function FollowUp() {
  useEffect(() => {
    const link = document.createElement("link");
    link.href =
      "https://mychart.childrenscolorado.org/mychart/Content/EmbeddedWidget.css";
    document.body.appendChild(link);

    const scriptController = document.createElement("script");
    scriptController.src =
      "https://mychart.childrenscolorado.org/mychart/Content/EmbeddedWidgetController.js";
    scriptController.async = false;
    document.body.appendChild(scriptController);

    const script = document.createElement("script");
    script.async = false;
    const scriptText = document.createTextNode(`
      var EWC = new EmbeddedWidgetController(
        {
          hostname: 'mychart.childrenscolorado.org',
          matchMediaString:'(max-width: 747px)',
          showToggleBtn:true
        }
      );`);
    script.appendChild(scriptText);
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(link);
      document.body.removeChild(scriptController);
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className="defaultContainer">
      <div id="scheduleContainer">
        <p style={{ textAlign: "center" }}>
          (If the screen is blank below, visit{" "}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://mychart.childrenscolorado.org/mychart/SignupAndSchedule/EmbeddedSchedule?id=406905,408286,317051,313492,18872,428867,319042,400505&dept=471008,511067,512034&vt=2943"
          >
            MyChart
          </a>)
        </p>
        <iframe
          style={{ border: "none", width: "100%", height: "500px" }}
          id="openSchedulingFrame"
          title="openSchedulingFrame"
          className="widgetframe"
          scrolling="yes"
          src="https://mychart.childrenscolorado.org/mychart/SignupAndSchedule/EmbeddedSchedule?id=406905,408286,317051,313492,18872,428867,319042,400505&dept=471008,511067,512034&vt=2943"
          allowFullScreen
        />
      </div>
    </div>
  );
}

export default FollowUp;
